export const format = (t, s = '') => {
  const a = [{ year: 'numeric' }, { month: '2-digit' }, { day: '2-digit' }];
  function formatDate(m) {
    const f = new Intl.DateTimeFormat('en', m);
    return f.format(t);
  }
  return a.map(formatDate).join(s);
};

export const parseUrlDate = (str) => {
  const y = str.substr(0, 4);
  const m = str.substr(4, 2) - 1;
  const d = str.substr(6, 2);
  const D = new Date(y, m, d);

  return D.getFullYear() === parseInt(y, 10) &&
    D.getMonth() === parseInt(m, 10) &&
    D.getDate() === parseInt(d, 10)
    ? D
    : 'invalid date';
};
